import React, { useState, useEffect } from 'react';
import axiosClient from 'api/axiosClient';
import { Row, Col, Container, Modal, ModalBody, Button } from 'reactstrap'; // Đã lược bỏ các import thừa của reactstrap
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import ReactPaginate from 'react-paginate';
import Loader from "react-loader-spinner";
import { updateBreadCrumbNews, updateSelecteDetail } from 'redux/actions/menu';
import { SETTING_IMAGE_URL } from 'utils/constants';
import useDebounce from 'hooks/useDebounce';
import './BrandIdentity.css';

const BrandItem = ({ item }) => {
    const intl = useIntl();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [downloading, setDownloading] = useState(false); // Thêm state quản lý loading khi tải file

    const togglePreview = () => setPreviewOpen(!previewOpen);
    const toggleAlert = () => setAlertOpen(!alertOpen);

    const filePreviewUrl = `${SETTING_IMAGE_URL}/${item.file_preview}`;
    const fileDownloadUrl = `${SETTING_IMAGE_URL}/${item.file}`;

    const handleDownload = async (e) => {
        e.preventDefault();
        if (downloading) return; // Ngăn chặn bấm liên tục khi đang tải

        setDownloading(true); // Bắt đầu hiệu ứng loading
        try {
            const response = await axiosClient.post(`/brand_identity/download/${item.id}`, {}, {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.file ? item.file.split('/').pop() : 'download');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error("Error downloading file via API:", error);
            if (error.response && error.response.status === 404) {
                setAlertOpen(true);
            } else {
                // Fallback tải trực tiếp nếu API lỗi
                const link = document.createElement('a');
                link.href = fileDownloadUrl;
                link.setAttribute('download', '');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }
        } finally {
            setDownloading(false); // Tắt hiệu ứng loading dù thành công hay thất bại
        }
    };

    useEffect(() => {
        let timer;
        if (alertOpen) {
            timer = setTimeout(() => {
                setAlertOpen(false);
            }, 3000);
        }
        return () => clearTimeout(timer);
    }, [alertOpen]);

    return (
        <Col md="6" sm="12" className="bi-item-wrapper">
            <div className="bi-item">
                <div className="bi-left" onClick={togglePreview} style={{ cursor: 'pointer' }}>
                    <img src={filePreviewUrl} alt={item.name} className="bi-img" />
                </div>
                <div className="bi-right">
                    <h4 className="bi-name" onClick={togglePreview} style={{ cursor: 'pointer' }}>{item.name}</h4>
                    <p className="bi-des">{item.des || ''}</p>
                    <a
                        href="#"
                        onClick={handleDownload}
                        className={`bi-download-btn ${downloading ? 'disabled' : ''}`}
                        style={{ 
                            pointerEvents: downloading ? 'none' : 'auto', 
                            opacity: downloading ? 0.6 : 1,
                            display: 'inline-flex',
                            alignItems: 'center'
                        }}
                    >
                        {downloading ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" style={{ width: '1rem', height: '1rem' }}></span>
                                {intl.formatMessage({ id: 'Downloading...'})}
                            </>
                        ) : (
                            intl.formatMessage({ id: 'Download', defaultMessage: 'Download' })
                        )}
                    </a>
                </div>
            </div>

            <Modal isOpen={previewOpen} toggle={togglePreview} size="lg" centered>
                <div className="position-relative" style={{ padding: '20px', borderBottom: '1px solid #E3E3E3' }}>
                    <h5 className="text-center m-0" style={{ fontSize: '1.25rem', fontWeight: 600, color: '#333' }}>{item.name}</h5>
                    <button type="button" className="close" style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', margin: 0, padding: 0, outline: 'none' }} onClick={togglePreview} aria-label="Close">
                        <span aria-hidden="true" style={{ fontSize: '1.75rem', lineHeight: 1 }}>&times;</span>
                    </button>
                </div>
                <ModalBody className="text-center pt-4">
                    <img src={filePreviewUrl} alt={item.name} style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }} />
                </ModalBody>
            </Modal>

            <div style={{
                position: 'fixed',
                top: alertOpen ? '20px' : '-100px',
                right: '20px',
                backgroundColor: '#ef5350',
                color: 'white',
                padding: '12px 20px',
                borderRadius: '4px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                opacity: alertOpen ? 1 : 0
            }}>
                <i className="nc-icon nc-bell-55 mr-2" style={{ fontSize: '1.2rem' }}></i>
                <span className="mr-3" style={{ fontSize: '0.95rem' }}>{intl.formatMessage({ id: 'FileNotFound', defaultMessage: 'The file does not exist or has been removed.' })}</span>
                <span style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.2rem', lineHeight: 1 }} onClick={toggleAlert}>&times;</span>
            </div>
        </Col>
    );
};

const BrandIdentity = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const itemsPerPage = 10;

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(updateBreadCrumbNews([
            {
                title: intl.formatMessage({ id: 'Home' }),
                path: "/"
            },
            {
                title: intl.formatMessage({ id: 'Media' }),
                path: "/media"
            },
            {
                title: intl.formatMessage({ id: 'Brand identity system' }),
                path: ""
            }
        ]));
        dispatch(updateSelecteDetail({ id: 9999 }));
    }, [dispatch, intl]);

    const debouncedSearchTerm = useDebounce(searchQuery, 500);

    useEffect(() => {
        const fetchItems = async () => {
            setLoading(true);
            try {
                const searchParam = debouncedSearchTerm ? `&searchText=${encodeURIComponent(debouncedSearchTerm)}` : '';
                const response = await axiosClient.get(`/brand_identity?page=${currentPage}&size=${itemsPerPage}${searchParam}`);
                if (response.data) {
                    setItems(response.data);
                    let totalCount = response.data.length;
                    if (response.total) {
                        const totalStr = String(response.total);
                        if (totalStr.includes('/')) {
                            totalCount = parseInt(totalStr.split('/')[1], 10) || totalCount;
                        } else {
                            totalCount = parseInt(totalStr, 10) || totalCount;
                        }
                    }
                    setPageCount(Math.ceil(totalCount / itemsPerPage));
                }
            } catch (error) {
                console.error("Error fetching brand identity items:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchItems();
    }, [debouncedSearchTerm, currentPage]);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected + 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="bi-container main-app">
            <Row className="row_title_custom" style={{ marginBottom: '30px' }}>
                <Col md="12" className="pl-0">
                    <span className="research_title_custom">
                        {intl.formatMessage({ id: 'Brand identity system', defaultMessage: 'Brand identity system' })}
                    </span>
                </Col>
            </Row>

            <div className="bi-filter-section" style={{ marginBottom: '20px' }}>
                <div className="cw-search-wrapper" style={{ display: 'flex', alignItems: 'center', backgroundColor: '#f4f4f4', padding: '10px 20px', borderRadius: '30px', maxWidth: '400px' }}>
                    <i className="nc-icon nc-zoom-split" style={{ marginRight: '10px', color: '#888' }}></i>
                    <input
                        type="text"
                        placeholder={intl.formatMessage({ id: 'Search...', defaultMessage: 'Search...' })}
                        value={searchQuery}
                        onChange={(e) => {
                            setSearchQuery(e.target.value);
                            setCurrentPage(1);
                        }}
                        className="cw-search-input"
                        style={{ border: 'none', backgroundColor: 'transparent', outline: 'none', width: '100%' }}
                    />
                </div>
            </div>

            {loading ? (
                <div className="text-center" style={{ padding: '50px' }}>
                    <Loader type="ThreeDots" color="var(--primary-color)" height="80" width="80" />
                </div>
            ) : (
                <>
                    <Row className="bi-grid">
                        {items.length > 0 ? (
                            items.map((item) => (
                                <BrandItem key={item.id} item={item} />
                            ))
                        ) : (
                            <Col md="12">
                                <p className="text-center">{intl.formatMessage({ id: 'NoItemsFound', defaultMessage: 'No items found.' })}</p>
                            </Col>
                        )}
                    </Row>

                    {pageCount > 1 && (
                        <div className="bi-pagination-wrapper">
                            <ReactPaginate
                                previousLabel={"←"}
                                nextLabel={"→"}
                                breakLabel={"..."}
                                pageCount={pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                activeClassName={"active"}
                                forcePage={currentPage - 1}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default BrandIdentity;